export default {

  setAlerts (state, { alerts }) {
    resetAlerts(state)
    alerts.map(alert => {
      state.alerts[alert.type][alert.status].unshift(alert)
    })
    orderByDate(state)
  },

  addAlert (state, { newAlert }) {
    state.alerts[newAlert.type][newAlert.status].unshift(newAlert)
    state.alerts[newAlert.type][newAlert.status].sort((a, b) => new Date(a.cc_timeslot) - new Date(b.cc_timeslot))
  },

  setRestid (state, { restId }) {
    state.restId = restId
  },

  updateAlertStatus (state, { alert, status }) {
    const index = state.alerts[alert.type][alert.status].findIndex(a => a.id === alert.id)

    state.alerts[alert.type][alert.status].splice(index, 1)
    alert.status = status
    state.alerts[alert.type][alert.status].unshift(alert)
    state.alerts[alert.type][alert.status].sort((a, b) => new Date(a.cc_timeslot) - new Date(b.cc_timeslot))
  }

}

function orderByDate (state) {
  state.alerts.cc.complete.sort((a, b) => new Date(a.cc_timeslot) - new Date(b.cc_timeslot))
  state.alerts.cc.pending.sort((a, b) => new Date(a.cc_timeslot) - new Date(b.cc_timeslot))
  state.alerts.pmb.complete.sort((a, b) => new Date(a.cc_timeslot) - new Date(b.cc_timeslot))
  state.alerts.pmb.pending.sort((a, b) => new Date(a.cc_timeslot) - new Date(b.cc_timeslot))
  state.alerts.oa.complete.sort((a, b) => new Date(a.cc_timeslot) - new Date(b.cc_timeslot))
  state.alerts.oa.pending.sort((a, b) => new Date(a.cc_timeslot) - new Date(b.cc_timeslot))
  state.alerts.d.complete.sort((a, b) => new Date(a.time_of_transaction) - new Date(b.time_of_transaction))
  state.alerts.d.pending.sort((a, b) => new Date(a.time_of_transaction) - new Date(b.time_of_transaction))
}

function resetAlerts (state) {
  state.alerts.cc.complete = []
  state.alerts.cc.pending = []
  state.alerts.pmb.complete = []
  state.alerts.pmb.pending = []
  state.alerts.d.complete = []
  state.alerts.d.pending = []
  state.alerts.oa.complete = []
  state.alerts.oa.pending = []
}



// WEBPACK FOOTER //
// ./src/store/alerts/mutations.js